import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'euStringToUSDate',
    standalone: false
})
export class EuStringToUSDate implements PipeTransform {
  transform(value: string): string {
    const newString = value.split('/');
    return [newString[1], newString[0], newString[2]].join('/');
  }
}
